import axios from "axios";
import React, { useEffect, useState } from "react";
import { createContext } from "react";
import { VARIABLES } from "../Constant";

export const JobOpeningContext = createContext(null);

function JobOpeningProvider({ children }) {
  const [rawJobPosting, setRawJobPosting] = useState([]);
  console.log(rawJobPosting);
  const [jobPostingCount, setJobPostingCount] = useState(0);

  const [isLoading, setIsLoading] = useState(true);

  const getJobPostingData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(VARIABLES.url + `/api/jobopening/?platform=career`);
      setRawJobPosting(res.data.data);
      setIsLoading(false);
      const total = res.data.count;
      setJobPostingCount(total)
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getJobPostingData();
  }, []);

  return (
    <div>
      <JobOpeningContext.Provider value={{ rawJobPosting, isLoading, jobPostingCount }}>
        {children}
      </JobOpeningContext.Provider>
    </div>
  );
}

export default JobOpeningProvider;
